export function formatUnknownError(err: unknown): string {
  if (err instanceof Error) return err.message;
  if (typeof err === "string") return err;
  try {
    return JSON.stringify(err);
  } catch {
    return String(err);
  }
}

type ImportRowFailure = {
  rowIndex: number;
  errors: ReadonlyArray<{ message: string }>;
};

/** Single-line-ish summary for toast descriptions (server row errors). */
export function summarizeImportRowFailureMessages(
  failedResults: readonly ImportRowFailure[],
  maxLen = 800
): string | undefined {
  const parts: string[] = [];
  for (const r of failedResults) {
    for (const e of r.errors) {
      parts.push(`行${r.rowIndex + 1}: ${e.message}`);
    }
  }
  if (parts.length === 0) return undefined;
  const joined = parts.join(" / ");
  return joined.length > maxLen ? `${joined.slice(0, maxLen - 1)}…` : joined;
}
